import React, { useEffect, useState } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { toast } from 'react-toastify';
import Loader from './loader';
import { listcategorycount } from '../service/dataservice';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [countdata, setCountData] = useState([]);
  useEffect(() => {
    listcategorycount().then((res) => {
      if (res.status) {
        setCountData(res.data.category_counts);
      }
    })
  }, []);
  const colors = ["primary", "success", "warning", "secondary", "info", "danger"];
  const icons = [
    "fa-heart",
    "fa-ring",
    "fa-gift",
    "fa-house",
    "fa-child",
    "fa-cake-candles"
  ];
  return (
    <div className="container-fluid p-4">
      <h2>Dashboard</h2>
      {loading && <Loader />}

      {/* Quick Stats */}
      <div className="row g-3 my-3">
        {countdata.map((item, index) => {
          const bgColor = colors[index % colors.length];
          const icon = icons[index % icons.length];
          return (
            <StatCard
              key={item._id}
              title={item.product_category.category_name}
              value={item.total}
              icon={icon}
              bg={bgColor}
            />
          );
        })}
      </div>


    </div>
  );
};

// ------------------ Stat Card ------------------
const StatCard = ({ title, value, icon, bg }) => (
  <div className="col-md-3">
    <div className={`card text-white bg-${bg}`}>
      <div className="card-body d-flex justify-content-between align-items-center">
        <div>
          <h5>{title}</h5>
          <h3>{value}</h3>
        </div>
        <i className={`fa ${icon} fa-2x`}></i>
      </div>
    </div>
  </div>
);



